/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnStripe.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnStripe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnStripe-view">
        <Helmet>
          <title>Stripe - CheckPlus</title>
        </Helmet>

        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="CnStripe-section">
          <div className="CnStripe-partnerwithstripe" />
        </div>

        <div className="CnStripe-section2">
          <div className="CnStripe-heading CnStripe-firstTxt">
            我们跟 Stripe 合作，安全地处理了所有信用卡付款。
          </div>
          <div className="CnStripe-cardContainer">
            <div className="CnStripe-visaIcon" />
            <div className="CnStripe-mastercardIcon" />
            <div className="CnStripe-amexIcon" />
            <div className="CnStripe-unionpayIcon" />
            <div className="CnStripe-applePay" />
            <div className="CnStripe-googlePay" />
          </div>
        </div>

        <div className="CnStripe-section3">
          <div className="CnStripe-featuresContainer">
            <div className="CnStripe-aes">AES-256</div>
            <div className="CnStripe-txt">
              所有卡号码均使用 AES-256
              技术加密，全球各大银行和政府也使用相同的加密技术。
            </div>
          </div>
          <div className="CnStripe-featuresContainer">
            <div className="CnStripe-pci" />
            <div className="CnStripe-txt">
              Stripe 是通过 PCI 认证的信用卡支付处理公司，以确保数据安全。
            </div>
          </div>
        </div>

        <div className="CnStripe-section4">
          <div className="CnStripe-heading CnStripe-text4">
            需要注册一个Stripe帐户？
          </div>

          <div className="CnStripe-notepadContainer">
            <div className="CnStripe-notepad" />
          </div>
          <div className="CnStripe-txt CnStripe-description4">
            不需要，当您注册 CheckPlus 的时候， 我们的系统会自动在我们端设置一个
            Stripe 帐户。 因此，您只需要通过一个平台处理所有付款。
          </div>
        </div>

        <div className="CnStripe-section5">
          <div className="CnStripe-logo" />
          <div className="CnStripe-txt CnStripe-description5">
            立即登记跟 Stripe 合作的 CheckPlus
          </div>
          <Link to="/OrgLogin">
            <div className="CnStripe-first-bar">立即登记</div>
          </Link>
        </div>

        <div className="CnStripe-footer">
          <div className="CnStripe-footerNav">
            <Link to="/CnTeam">
              <div className="CnStripe-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnStripe-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnStripe-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="CnPrivacyPolicy-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnPrivacyPolicy-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnStripe-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnStripe;
